/*
  Warning!
  The file build-info.json will be overwritten during the build phase.
  Do not move or rename this file without changing the build-docker-app.yaml and the dockerfile.
*/
import buildInfo from './build-info.json';

export const TRACKING_VERSION = buildInfo.buildDate;
